import cacheService from '../../../services/cacheService';
import { apiV2Client } from '../../../services/apiClient';
import { AssessmentState } from '../models/assessment';

export const invalidateAssessmentCache = (assessmentId: string): void => {
  cacheService.removeAllInPath(`/assessment/${assessmentId}/localized`);
};

export const getAssessmentById = (assessmentId: string, responseID?: string): Promise<AssessmentState> => {
  const endpoint = `/assessment/${assessmentId}/localized?locale=en-US${responseID ? `&responseID=${responseID}` : ''}`;
  const cached = cacheService.get(endpoint);
  if (cached) return cached;

  const request = apiV2Client.get<AssessmentState>(endpoint).then(({ data }) => data);
  cacheService.set(endpoint, request, 5);
  return request;
};
